import { memo } from "react";

import Badge from "ui/components/Badge/Badge";
import {
  CRON_JOB_EXECUTION_STATUS_LABELS,
  CRON_JOB_EXECUTION_STATUS_VARIANTS,
} from "services/api/cronjobs/consts";
import { CronJobExecutionStatus } from "services/api/cronjobs/types";

interface CronJobExecutionStatusBadgeProps {
  status: CronJobExecutionStatus | string;
}

/** Status jedne obrade. Nepoznat status se ispisuje doslovno, sivo. */
const CronJobExecutionStatusBadge: React.FC<CronJobExecutionStatusBadgeProps> = ({ status }) => {
  const known = status as CronJobExecutionStatus;

  return (
    <Badge
      text={CRON_JOB_EXECUTION_STATUS_LABELS[known] ?? status}
      variant={CRON_JOB_EXECUTION_STATUS_VARIANTS[known] ?? "secondary"}
      height="small"
      showDot={status === "running"}
    />
  );
};

export default memo(CronJobExecutionStatusBadge);
